import type { FC } from 'react';
import { Label } from '@patternfly/react-core/dist/dynamic/components/Label';
import './Badge.scss';
import { useTranslation } from 'react-i18next';

const DevPreviewBadge: FC = () => {
  const { t } = useTranslation();
  return <Label className="ocs-preview-badge">{t('console-shared~Dev preview')}</Label>;
};

export default DevPreviewBadge;
